export function PasswordResetException(message, reset_success = false) {
  this.message = message;
  this.reset_success = reset_success;
  this.name = 'PasswordResetException';
}


export function AuthenticationException(notifyParams, additionalParams = {}) {
  this.notifyParams = { ...notifyParams, ...additionalParams };
  this.name = 'AuthenticationException';
}


export function FatalErrorException(message) {
  this.message = message;
  this.name = 'FatalErrorException';
}


export function FatalWebErrorException(message) {
  this.message = message;
  this.name = 'FatalWebErrorException';
}


export function APIException(message, text, additionalParams = {}) {
  this.message = message;
  this.text = text;
  this.name = 'APIException';
  this.notifyParams = {
    title: message || 'Error Encountered',
    text: text || 'See error details in screen.',
    ignoreDuplicates: true,
    ...additionalParams,
  };
  return this;
}


export function HTTPException(message) {
  this.message = message;
  this.name = 'HTTPException';
}


export function NotFoundException(message, additionalParams = {}) {
  this.message = message;
  this.name = 'NotFoundException';
  this.notifyParams = {
    title: message || this.name,
    ignoreDuplicates: true,
    ...additionalParams,
  };
}


export function UserException(message, additionalParams = {}) {
  this.message = message;
  this.name = 'UserException';
  this.notifyParams = {
    title: message || this.name,
    ...additionalParams,
  };
}
